import { BehaviorParameters } from 'rangeConfig/@types';
import { autoFillDoorsAtTarget, autoFillDoors } from 'rangeConfig/pax/utils/autoFillDoors';
import { removeProductsAndUpdateInnerLights } from 'rangeConfig/pax/utils/removeProducts';
import { ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, Entity, ProductComponent } from '@inter-ikea-core/core';

// Check to make sure doors on the frame are not identical to the new doors
// If they are then we have no reason to replace the doors
const doosOnFrameIsIdenticalToNewDoor = (doorsOnFrame: Entity[], newDoorProductId: string) => {
  if (!doorsOnFrame || doorsOnFrame.length === 0) return false;

  const currentDoorIds = doorsOnFrame.map(
    door => door.getComponent<ProductComponent>(ComponentIds.PRODUCT_COMPONENT_ID)?.productRef
  );
  const matchingDoors = currentDoorIds.filter(door => door === newDoorProductId).filter(Boolean);

  // If all doors have the same product id as the new door then we will not replace the doors
  return matchingDoors.length === currentDoorIds.length;
};

const autoFillDoorsBehavior = (autoFillDefault: string[]) => ({
  coreApi,
  dispatch,
  props,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  coreApi.toggleExhaustiveValidation(true);
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (selectedEntity) {
    const doorsOnFrame = coreApi.entities.getDescendantsWithComponent(
      selectedEntity,
      ComponentIds.DOOR_COMPONENT_ID
    );

    const doorsIdentical = doosOnFrameIsIdenticalToNewDoor(doorsOnFrame, props.coreProductId);

    if (doorsIdentical) return;

    autoFillDoorsAtTarget(props.coreProductId, autoFillDefault, coreApi, selectedEntity, products);
  } else {
    const slidingDoors = coreApi.entities.getByProductTypes([
      ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
      ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM
    ]);

    if (slidingDoors && slidingDoors.length > 0) {
      removeProductsAndUpdateInnerLights(slidingDoors, coreApi);
    }
    autoFillDoors(props.coreProductIds[0], autoFillDefault, coreApi, dispatch, products);
  }
  coreApi.toggleExhaustiveValidation(false);
};

export default autoFillDoorsBehavior;
